import { BussesPassengersCounter } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/BussesPassengersCounter";
import { calculateTotalRequiredFromBusCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/common";
import { StatContainer } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/StatContainer";
import { CAPACITY_PER_BUS } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/constants";
import { AltTransBusCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC, useMemo } from "react";
import { Field, Flex, Text } from "shared/components/Spor";
import { Nullish } from "shared/utils/objectUtils";

type TotalProgressionBoxProps = {
  totalCoverage: AltTransBusCoverage;
  totalPassengersRequiringTransport: Nullish<number>;
};

export const TotalProgressionBox: FC<TotalProgressionBoxProps> = ({
  totalCoverage,
  totalPassengersRequiringTransport,
}) => {
  const sumBuses = useMemo(
    () => calculateTotalRequiredFromBusCoverage(totalCoverage),
    [totalCoverage],
  );

  const passengers =
    totalPassengersRequiringTransport ?? sumBuses * CAPACITY_PER_BUS;

  return (
    <Field alignSelf="flex-start" minWidth="220px" maxWidth="250px">
      <Flex alignItems="center">
        <Text variant="sm" fontWeight="bold" color="text.main">
          Maks brudd:
        </Text>
        <BussesPassengersCounter
          vehicles={sumBuses}
          passengers={passengers}
          vehiclesFromMeasureCard={null}
        />
      </Flex>

      <Flex direction="column" gap="1" mt="1">
        <StatContainer
          semantics="alarm"
          title="Behov"
          value={totalCoverage.stillRequired}
        />

        <StatContainer
          semantics="warning"
          title="Bestilt"
          value={totalCoverage.totalOrdered}
        />

        <StatContainer
          semantics="info"
          title="Bekreftet"
          value={totalCoverage.totalConfirmed}
        />

        <StatContainer
          semantics="success"
          title="Møtt opp"
          value={totalCoverage.totalOperational}
        />
      </Flex>
    </Field>
  );
};
